import { useMemo } from 'react';
import { useMeContext } from 'modules/me';
import { DEFAULT_WEEKDAY, WeekDay } from 'modules/muiPickers/CustomLuxonUtils';

type WeekDayType = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export const weekUris = [
  'urn:replicon:day-of-week:sunday',
  'urn:replicon:day-of-week:monday',
  'urn:replicon:day-of-week:tuesday',
  'urn:replicon:day-of-week:wednesday',
  'urn:replicon:day-of-week:thursday',
  'urn:replicon:day-of-week:friday',
  'urn:replicon:day-of-week:saturday'
];

export const useWeekStartDay = (): WeekDayType => {
  const me = useMeContext();

  return useMemo(() => {
    const weekDay = (me?.workWeekStartDay?.uri as WeekDay) || DEFAULT_WEEKDAY;
    return weekUris.indexOf(weekDay) as WeekDayType;
  }, [me?.workWeekStartDay?.uri]);
};
